import { render } from "./textAnswer.vue?vue&type=template&id=57a3288a&scoped=true"
import script from "./textAnswer.vue?vue&type=script&lang=js"
export * from "./textAnswer.vue?vue&type=script&lang=js"

import "./textAnswer.vue?vue&type=style&index=0&id=57a3288a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a3288a"]])

export default __exports__